import { IDictionaryTag } from '../../../interfaces/Dictionary.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetDictionaryTagsParams {
  categoryId: string;
}

export const getDictionaryTags = ({ categoryId }: IGetDictionaryTagsParams): Promise<IDictionaryTag[]> => {
  return customAxios.get(`/dictionary/categories/${categoryId}/tags`);
};
